import { useTranslation } from "react-i18next";
import KeycloakIDPAdapter from "common/Adapters/IDPAdapter/KeycloakIDPAdapter";
import { Button, Content, useTranslator } from "@sia/style-guide";
import Page from "../../Page";

const AlreadyHaveSiaIdPage = () => {
  const { i18n } = useTranslation();
  const translate = useTranslator();

  const createLoginUrl = () => {
    window.location.href = KeycloakIDPAdapter.createLoginUrl(i18n.language);
  };

  const createRegisterUrl = () => {
    const registerUrl = `${KeycloakIDPAdapter.createLoginUrl(i18n.language)}#/register`;
    window.location.href = registerUrl;
  };

  return (
    <Page>
      <Content width={"slim"} centeredTexts={true}>
        <h3 className="productive-heading-04 sia-text-12">{translate("wizard.already-have-sia-id.title")}</h3>
        <p>
          <Button onClick={createLoginUrl}>{translate("wizard.already-have-sia-id.login.button.label")}</Button>
          <Button kind="secondary" onClick={createRegisterUrl} className={"sia-margin-02-left button"}>
            {translate("wizard.already-have-sia-id.create.button.label")}
          </Button>
        </p>
      </Content>
    </Page>
  );
};

export default AlreadyHaveSiaIdPage;
